const ApiUrl = 'https://remoterv2stg.inova.si/api/system/';
const GoogleClientId = '434257015459-fioeiescnalas3kondtakm25kf5iv52i.apps.googleusercontent.com';

export const environment = {
  production: false,
  apiUrl: ApiUrl,
  googleClientId: GoogleClientId
};
